import { cn } from '../../lib/cn.js';

const inputClass =
  'border-hairline bg-base/50 text-ink h-9 w-full rounded-lg border px-2.5 text-sm focus:border-accent/60 focus:outline-none';

export function Field({
  label,
  children,
  hint,
  className,
}: {
  label: string;
  children: React.ReactNode;
  hint?: string;
  className?: string;
}) {
  return (
    <label className={cn('block', className)}>
      <span className="label-micro mb-1 block">{label}</span>
      {children}
      {hint && <span className="text-ink-soft/60 mt-1 block text-[10px]">{hint}</span>}
    </label>
  );
}

export function TextInput(props: React.InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} className={cn(inputClass, props.className)} />;
}

export function SelectInput(props: React.SelectHTMLAttributes<HTMLSelectElement>) {
  return <select {...props} className={cn(inputClass, 'appearance-none pr-8', props.className)} />;
}

export function TextArea(props: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <textarea
      {...props}
      className={cn(
        'border-hairline bg-base/50 text-ink w-full rounded-lg border px-2.5 py-2 text-sm focus:border-accent/60 focus:outline-none',
        props.className,
      )}
    />
  );
}

/** A pill for a status/badge. */
export function Pill({
  children,
  tone = 'neutral',
}: {
  children: React.ReactNode;
  tone?: 'neutral' | 'accent' | 'success' | 'warning' | 'danger';
}) {
  const tones: Record<string, string> = {
    neutral: 'bg-raised/60 text-ink-soft',
    accent: 'bg-accent/12 text-accent',
    success: 'bg-success/12 text-success',
    warning: 'bg-warning/12 text-warning',
    danger: 'bg-danger/12 text-danger',
  };
  return (
    <span className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-[11px]', tones[tone])}>
      {children}
    </span>
  );
}
